import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('popup', ['currentPopupOptions']),
    classModifiers() {
      return {
        'popup-generic-small': true,
        'popup-generic-small--icon': (this.currentPopupOptions && this.currentPopupOptions.icon),
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/modal/layouts/generic-small.js